import Vue from 'vue';
import VueRouter from 'vue-router';
import {store} from './components/store.js';
import AppComponent from './components/appComponent.vue';

//Pages
import Main from './pages/main.vue';
import Cultures from './pages/cultures.vue';
import Culture from './pages/culture.vue';
import News from './pages/news.vue';
import New from './pages/new.vue';
import Articles from './pages/articles.vue';
import FieldNews from './pages/field_news.vue';
import Promos from './pages/promos.vue';
import Promo from './pages/promo.vue';
import Products from './pages/products.vue';
import Product from './pages/product.vue';
import Videos from './pages/videos.vue';
import Video from './pages/video.vue';
import Contacts from './pages/contacts.vue';
import Distributors from './pages/distributors.vue';
import Weeds from './pages/weeds.vue';
import Pests from './pages/pests.vue';
import About from './pages/about.vue';
import Diseases from './pages/diseases.vue';
import CookiePolicy from './pages/cookie.vue';
import Terms from './pages/terms.vue';

import vSelect from 'vue-select'
import Meta from 'vue-meta';


Vue.use(VueRouter);
Vue.use(Meta);
Vue.component('v-select', vSelect);

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);


var browserDetecter = function() {

    var browser = 'unknown';

    var is_chrome = !!window.chrome && !is_opera;
    if (is_chrome) {
        browser = 'chrome';
    }
    var is_explorer= typeof document !== 'undefined' && !!document.documentMode;
    if (is_explorer) {
        browser = 'ie';
    }
    var is_firefox = typeof window.InstallTrigger !== 'undefined';
    if (is_firefox) {
        browser = 'firefox';
    }
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (is_safari) {
        browser = 'safari';
    }
    var is_opera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    if (is_opera) {
        browser = 'is_opera';
    }

    if (window.navigator.userAgent.indexOf("Edge") > -1) {
        browser = 'edge';
    }

    window.browser = browser;
    document.body.classList.add('browser-' + browser);
};
browserDetecter();

const routesList = [
    {path : '/', name: 'Main', component: Main},
    {path: '/about/', name: 'About', component: About},
    {path: '/cultures/', name: 'Cultures', component: Cultures},
    {path: '/cultures/:slug/', name: 'Culture', component: Culture},
    {path: '/products/', name: 'products', component: Products},
    {path: '/products/:category/', name: 'Products', component: Products},
    {path: '/products/:category/:slug/', name: 'Product', component: Product},
    {path: '/video/', name: 'Videos', component: Videos},
    {path: '/video/:slug/', name: 'Video', component: Video},
    {path: '/contacts/', name: 'contacts', component: Contacts},
    {path: '/contacts/:slug/', name: 'Contacts', component: Contacts},
    {path: '/distributors/', name: 'Distributors', component: Distributors},
    {path: '/weeds/', name: 'weeds', component: Weeds},
    {path: '/weeds/:slug/', name: 'Weeds', component: Weeds},
    {path: '/pests/', name: 'pests', component: Pests},
    {path: '/pests/:slug/', name: 'Pests', component: Pests},
    {path: '/diseases/', name: 'diseases', component: Diseases},
    {path: '/diseases/:slug/', name: 'Diseases', component: Diseases},
    {path: '/news/', name: 'News', component: News},
    {path: '/news/:slug/', name: 'New', component: New},
    {path: '/articles/', name: 'Articles', component: Articles},
    {path: '/articles/:slug/', name: 'Article', component: New},
    {path: '/field-news/', name: 'FieldNews', component: FieldNews},
    {path: '/field-news/:slug/', name: 'FieldNew', component: New},
    {path: '/promos/', name: 'Promos', component: Promos},
    {path: '/promos/:slug/', name: 'Promo', component: Promo},
    {path: '/cookie-policy/', name: 'Cookie', component: CookiePolicy},
    {path: '/terms-of-use/', name: 'Terms', component: Terms}
];

const router = new VueRouter({
	mode: 'history',
    routes: routesList,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});

new Vue({
	el: "#app",
	router: router,
	store: store,
  render: (h) => h(AppComponent),
});
